export const SET_SALES_INFO_ORG = 'SET_SALES_INFO_ORG';
export const SET_SALES_INFO_DIVISION = 'SET_SALES_INFO_DIVISION';
export const SET_SALES_INFO_DIST_CHANNEL = 'SET_SALES_INFO_DIST_CHANNEL';
export const SET_SALES_INFO_CURRENCY = 'SET_SALES_INFO_CURRENCY';
export const SET_SALES_INFO_DATA_LOADED = 'SET_SALES_INFO_DATA_LOADED';
export const SET_SALES_INFO_EMAIL_DOMAIN_BLACKLIST = 'SET_SALES_INFO_EMAIL_DOMAIN_BLACKLIST';
export const SET_SELECTED_SALES_INFO_DATA = 'SET_SELECTED_SALES_INFO_DATA';